const React = require('react');
const PropTypes = require('prop-types');
require('./PercentageBar.scss');


const PercentageBar = ({ backgroundColor, foregroundColor, height, percentage, width }) => (
    <span className="percentage-bar">
        <span
            className="percentage-bar__outer-bar"
            style={{ backgroundColor, height, width }}
        >
            {
                percentage &&
                <span
                    className="percentage-bar__inner-bar"
                    style={{ backgroundColor: foregroundColor, height, width: `${percentage}%` }}
                />
            }
        </span>
    </span>
);


PercentageBar.defaultProps = {
    backgroundColor: '#69788c',
    foregroundColor: '#00bfdc',
    height: 10,
    width: '100%',
};

PercentageBar.propTypes = {
    backgroundColor: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    foregroundColor: PropTypes.string,
    percentage: PropTypes.number.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};


module.exports = PercentageBar;
